import React from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import logo from '../../assets/logoWhite.svg';
import { useHistory } from 'react-router-dom';

const useStyles: any = makeStyles(
  (theme: Theme) =>
    createStyles({
      logo: {
        '&:hover': {
          cursor: 'pointer',
        },
        marginRight: 24,
      },
    }),
  { name: 'Logo' },
);

const Logo: React.FC<{ noLink?: boolean }> = ({ noLink = false }) => {
  const classes = useStyles();
  const history = useHistory();

  return <img onClick={noLink ? undefined : () => history.push('/')} className={classes.logo} src={logo} alt="Card.Gift logo" />;
};

export default Logo;
